import { useEffect } from 'react';
import { FieldPath, SetValueConfig } from 'react-hook-form';

export function useFormSetValue<TData extends object>(
  name: FieldPath<TData>,
  value: any,
  setValue?: (name: any, value: any, options?: SetValueConfig) => void,
) {
  useEffect(() => {
    if (value !== '') setValue?.(name, value);
  }, [setValue, value]);
}
